import { cardEnumsToCardState } from '../../../../utils/cards.ts';
export function getHandCardsToDisable(remainingCardsToSelect, playerCardState) {
    if (remainingCardsToSelect.length === 0) return undefined;
    const disableState = {};
    Object.entries(playerCardState).forEach(([cardKey, count])=>{
        const card = Number(cardKey);
        const shouldDisable = !remainingCardsToSelect.includes(card);
        if (shouldDisable) disableState[card] = count;
    });
    return disableState;
}
export function getOutOfStockCardsToDisable(bankStockByCard, selectedCards, remainingCardsToSelect) {
    const selectedCounts = cardEnumsToCardState(selectedCards);
    const displayedCounts = cardEnumsToCardState(remainingCardsToSelect);
    const disableState = {};
    Object.entries(bankStockByCard).forEach(([cardKey, stock])=>{
        const card = Number(cardKey);
        var _selectedCounts_card;
        const selectedCount = (_selectedCounts_card = selectedCounts[card]) !== null && _selectedCounts_card !== void 0 ? _selectedCounts_card : 0;
        const remainingStock = stock - selectedCount;
        var _displayedCounts_card;
        const displayedCount = (_displayedCounts_card = displayedCounts[card]) !== null && _displayedCounts_card !== void 0 ? _displayedCounts_card : 0;
        const isDepleted = remainingStock <= 0;
        if (isDepleted && displayedCount > 0) disableState[card] = displayedCount;
    });
    return disableState;
}
